import { Box, type BoxProps } from '@mui/material'

/**
 * A simple box element that fully centers its children along both axes.
 */
export function CenteredBox({ children, sx, ...props }: BoxProps) {
    return (
        <Box
            sx={{
                display: 'grid',
                placeItems: 'center',
                minHeight: '100%',
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    )
}
